import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  Card, CardBody, CardTitle, Col, Row,
} from 'reactstrap';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';

function Scanners(props) {
  const { t } = props;

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="12">
            <Card>
              <CardBody>
                <CardTitle className="h4">{t('Scanners')}</CardTitle>

                <Can i="see" this="Settings">
                  <BaseGrid
                    url="/api/zebra/scanners"
                    hasSearch
                    config={{
                      columns: {
                        id: { label: 'ID', sort: true },
                        scanner_code: { label: 'Code', sort: true },
                        device_identifier: { label: 'Device Identifier', sort: true },
                        ip: {
                          label: 'IP',
                          sort: true,
                          format: (value) => value || '',
                        },
                        app_version: {
                          label: 'App Version',
                          sort: true,
                          format: (value) => value || '',
                        },
                        last_used_by_name: {
                          label: 'Last Used By',
                          sort: true,
                          format: (value) => value || '',
                        },
                        last_used_at: {
                          label: 'Last Used At',
                          sort: true,
                          date: {},
                        },
                      },
                      pagination: {
                        sort: 'last_used_at',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }}
                  />
                </Can>

                <Can not i="see" this="Settings"><p>{t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Scanners.defaultProps = {
  t: (x) => x,
};

Scanners.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({}), {})(withTranslation()(Scanners));
